import script from "./UploadMetting.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadMetting.vue?vue&type=script&setup=true&lang=js"

import "./UploadMetting.vue?vue&type=style&index=0&id=6a923a1d&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a923a1d"]])

export default __exports__